export const multiActionMiddleware = store => next => action => {
  if (!Array.isArray(action)) return next(action)
  return action.map(a => store.dispatch(a))
}
